import { cloneDeep, uniqBy } from "lodash";
import React, { useEffect, useState } from "react";
import AppButton from "../../common/AppButton";
import AppInput from "../../common/AppInput";
import numberFormat from "../../common/numberFormat";
import api from "../../config/api";
import colors from "../../config/colors";
import config from "../../config/config";
import SmallForm from "../../skelliton/SmallForm";
import { MdMenu } from "react-icons/md";
import { toast } from "react-toastify";
import { getExpenseCategories } from "../../stores/ExpenseCategoryStore";
import { useQuery } from "@tanstack/react-query";

const size = config.iconSize;
const formInit = {
  date: new Date(),
  category: "",
  amount: "",
  invoice: "",
  comment: "",
};
export default function EditExpenseModel() {
  const [disabled, setDisabled] = useState(false);

  const Body = ({ onDone, data }) => {
    const [loading, setLoading] = useState(true);

    const { data: categories } = useQuery({
      queryFn: () => getExpenseCategories(),
      queryKey: ["expenseCategory"],
    });

    const [form, setForm] = useState(
      cloneDeep({ ...data, category: { _id: data._id, name: data.category } })
    );
    // console.log({ name: data.category });
    const handleSubmit = async (event) => {
      event.preventDefault();
      if (!form.category) {
        document.querySelector("#category input").focus();
        return false;
      }

      setDisabled(true);
      const res = await api.put("expenses", {
        ...form,
      });
      if (!res.ok) {
        setDisabled(false);
        toast.error(res.originalError.message);
      }

      setForm(formInit);
      setDisabled(false);
      toast.success("Expense has been successfully added.");
      onDone && onDone();
    };
    const handleChange = ({ target }) => {
      const name = target.name;
      const value = target.value;
      setForm({ ...form, [name]: value });
    };

    return (
      <form id="form" onSubmit={handleSubmit}>
        <br />
        <br />
        {!categories && (
          <div className="d-flex" style={{ justifyContent: "center" }}>
            <SmallForm />
          </div>
        )}
        {categories && (
          <div style={{ padding: "0px 30px" }}>
            <div className="d-flex" style={{ gap: "0px 30px" }}>
              <AppInput
                type="date"
                name="date"
                placeholder="Date"
                label="Date"
                floatLabel
                value={form.date}
                mask="99/99/9999"
                slotChar="DD/MM/YYYY"
                onChange={handleChange}
                required
              />
              <AppInput
                type="dropdown"
                options={uniqBy(
                  [
                    form.category,
                    ...categories?.map((i) => {
                      return { ...i, name: i.category };
                    }),
                  ],
                  (i) => i?._id
                )}
                noClear
                name="category"
                id="category"
                value={form.category}
                filterBy="name"
                onChange={handleChange}
                label="Category"
                floatLabel
                containerStyle={{ height: 95 }}
              />
            </div>
            <br />
            <br />

            <div className="d-flex" style={{ gap: "0px 30px" }}>
              <AppInput
                name="amount"
                value={numberFormat(form.amount)}
                onChange={handleChange}
                required
                label="Amount ($)"
                floatLabel
              />
              <AppInput
                name="invoice"
                value={form.invoice}
                onChange={handleChange}
                required
                label="Invoice"
                floatLabel
              />
              <AppInput
                name="comment"
                value={form.comment}
                onChange={handleChange}
                required
                label="Comment"
                floatLabel
              />
            </div>
          </div>
        )}
        <br />
        <br />
        <br />
      </form>
    );
  };
  const Header = () => {
    return (
      <span className="d-flex" style={{ alignItems: "center" }}>
        <MdMenu size={size} color={colors.silver} style={{ marginRight: 5 }} />
        <b>Edit Expenses</b>
      </span>
    );
  };
  const Footer = () => {
    return (
      <AppButton
        disabled={disabled}
        text="Save"
        form="form"
        type="submit"
        className="text-primary btn-light"
      />
    );
  };

  return {
    Body,
    Header,
    Footer,
  };
}
